@if (renderedIds) {
  @for (itemId of renderedIds; track trackBy(i, itemId); let i = $index) {
    <div #itemWrapper class="item-wrapper" [id]="itemId" [class.hidden]="isHidden(itemId)">
      <ng-container
        *ngTemplateOutlet="itemTemplate; context: createItemTemplateContext(getRenderedItemById(itemId), i)"
      ></ng-container>
    </div>
  }
}
